module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "dabef9d1bfb79-d1e356"
    }
  }, [_c('span', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('h2', {
    staticClass: "acknowledgements-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text"
  }, [_vm._v("Mr Nick Sayers at Hodder & Stoughton. His belief in me and the manuscripts kept me going.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Kate Lyall-Grant and all at Severn House Publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Mr David Grossman, my literary agent.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("David Meykell, clerk of the course, Leicester Racecourse, for allowing me to ‘do’ a murder on his racecourse.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Roderick Duncan, clerk of the course, Southwell Racecourse.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Jean Hedley, clerk of the course, Nottingham Racecourse.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Mark McGrath, former manager, Best Western North Shore Hotel and Golf Course, Skegness.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Bill Hutchinson, present manager, and all the lovely staff at the above hotel with special thanks to Gavin Disney, Dan, Nikki and Katie for all their help.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Sarah at Sarah’s Flowershop.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("All the library staff at Bingham, Radcliffe-on-Trent and Nottingham Central, with special thanks to Steve and to Rosie for her expertise on computers.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("David and Anne Brown, printers and friends for bailing me out – twice – and finding just where chapters twelve and thirteen had disappeared to!")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Lois from Crime Readers Group, a savvy lady who gave me confidence at the start.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("The police at Skegness and the staff at Nottingham Prison for checking facts.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Management at The Dirty Duck at Woolsthorpe.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Kirsty at The Unicorn Hotel at Gunthorpe.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("Vickie Litchfield at The Royal Oak, Radcliffe-on-Trent.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text-indented"
  }, [_vm._v("And for all the people who have helped me in whatever way during the course of writing the ‘Harry’ novels, may I say a very big thank you and have a great read.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e6da6ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106403_epub_ack.vue
// module id = 75
// module chunks = 0